import React from 'react'
import './giveaway.css'

const Giveaway = () => {
    return (
        <>
            <div className='our-giveaway'>
                <div className='our-giveaway-heading'>
                    <div>
                        <h2>
                            Community <span>Giveaways!</span>
                        </h2>
                    </div>
                </div>

                <div className='giveaway-content'>
                    <div>
                        {/* <p>
                            Every minute of every day, we’ve been putting our
                            heart and soul into creating ways to reward our
                            community that will ensure our product increases in
                            scarcity and our holders are consistently benefiting
                            from holding Legends of Shangu NFT’s.
                        </p> */}
                        {/* <span>The Legends of Shangu have awakened.</span> */}

                        <div class='container'>
                            <div class='timeline-block timeline-block-right'>
                                <div class='marker'></div>
                                <div class='timeline-content'>
                                    <h3>10% SOLD</h3>
                                    <span>
                                        10 Collectors will win a Legends of
                                        Shangu NFT 10/10 collection promo dollar
                                        bill.
                                    </span>
                                </div>
                            </div>

                            <div class='timeline-block timeline-block-right'>
                                <div class='marker'></div>
                                <div class='timeline-content'>
                                    <h3>30% SOLD</h3>
                                    <span>
                                        A free Legends of Shangu NFT will be
                                        airdropped to 20 collectors in the
                                        community.{' '}
                                    </span>
                                </div>
                            </div>

                            <div class='timeline-block timeline-block-right'>
                                <div class='marker'></div>
                                <div class='timeline-content'>
                                    <h3>50% SOLD</h3>
                                    <span>
                                        $50,000 donated to the Charlie Rocket
                                        Foundation and $10,000 in ETH air
                                        dropped to 10 people that minted.{' '}
                                    </span>
                                </div>
                            </div>

                            <div class='timeline-block timeline-block-right'>
                                <div class='marker'></div>
                                <div class='timeline-content'>
                                    <h3>70% SOLD</h3>
                                    <span>
                                        5 Obsidian super rare Legends of Shangu
                                        NFT’s air dropped to 5 people that
                                        minted.{' '}
                                    </span>
                                </div>
                            </div>

                            <div class='timeline-block timeline-block-right'>
                                <div class='marker'></div>
                                <div class='timeline-content'>
                                    <h3>90% SOLD</h3>
                                    <span>
                                        $20,000 in ETH distributed at random to
                                        20 people in the community plus Build
                                        the Legends of Shangu inner circle
                                        private access Discord.{' '}
                                    </span>
                                </div>
                            </div>

                            <div class='timeline-block timeline-block-right'>
                                <div class='marker'></div>
                                <div class='timeline-content'>
                                    <h3>100% SOLD</h3>
                                    <span>
                                        Initiate Main Giveaway Raffle and
                                        announcement of project 2!
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='main-giveaway'>
                <div className='our-giveaway-heading'>
                    <div>
                        <h2>
                            Main <span>Giveaway Raffle Draw</span>
                        </h2>
                    </div>
                </div>
                <div className='main-giveaway-content'>
                    <h2>
                        1st Prize Winner{' '}
                        <span>Mercedes a45s AMG or $75,000 USD</span>
                    </h2>
                    <h2>
                        2nd Prize Winner <span>$25,000 USD</span>
                    </h2>
                    <h2>
                        3rd Prize Winner <span>$10,000 USD</span>
                    </h2>

                    <p>
                        $30,000 Distributed between 30 holders! <br />- 3 Minters will
                        receive a Rolex each! <br />- 7 sets of 12 animals will be
                        released in Gold (84 Total)! <br />
                        Holders will receive a limited edition 1 of 1 dollar
                        bill artwork created by David Huynh featuring your Gold
                        NFT. <br />
                        -10 holders will receive a free Jumper from our limited
                        edition merch line.
                    </p>

                    <h3>
                        <span>
                            <strong>LEGENDS PARTY</strong>
                        </span>{' '}
                        We will be hosting launch events in all the major cities
                        that our team resides in on luxury superyachts! We
                        understand it’s not the most convenient time to travel
                        so instead of doing one big party, we will host
                        exclusive superyacht events for holders to connect and
                        network.
                    </h3>
                </div>
            </div>
        </>
    )
}

export default Giveaway
